import { render, staticRenderFns } from "./ClaimListing.vue?vue&type=template&id=481ea820"
import script from "./ClaimListing.vue?vue&type=script&lang=js"
export * from "./ClaimListing.vue?vue&type=script&lang=js"
import style0 from "./ClaimListing.vue?vue&type=style&index=0&id=481ea820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports